import { Children, type PropsWithChildren } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import { StyleSheet } from 'react-native';

import { LI, UL } from '@expo/html-elements';
import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const Stack = (props: StackProps) => {
  const { lineBreakAfter, children, testID } = props;

  const flattenedChildren = flattenChildren(children); // NOTE: To unwrap fragments

  return (
    <UL style={styles.stack} testID={testID}>
      {Children.map(flattenedChildren, (child, index) => {
        const isLastItem = index === flattenedChildren.length - 1;
        const hasLineBreakAfter = index > 0 && typeof lineBreakAfter === 'number' && index % lineBreakAfter === 0; // prettier-ignore
        const shouldApplyLineBreak = hasLineBreakAfter && !isLastItem;

        return (
          <>
            {shouldApplyLineBreak ? <LI style={styles.lineBreakItem} /> : null}
            {child}
          </>
        );
      })}
    </UL>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  stack: {
    display: 'flex', // override default style
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: theme.spacing['1'],
    columnGap: theme.spacing['4'],
    marginTop: theme.spacing['4'],
  },
  lineBreakItem: {
    width: '100%',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type StackProps = PropsWithChildren<{
  /**
   * Specifies the number of items after which a line break should occur.
   */
  lineBreakAfter?: number;
  testID?: string;
}>;
